module.exports = __webpack_public_path__ + "img/scrisoare-tata.b0bfec1c.jpg";